import useErrorMessageHandler from '@/@core/helpers/errorMessageHandler';
import { useCallApi } from '@/@core/services/axiosCall';
import {
  reactive,
  Ref,
  ref,
  toRefs,
  unref
} from '@vue/composition-api';
import { defineStore } from 'pinia';

export const useCommodityStore = defineStore('commodity', () => {
  const state = reactive({
    total: 0,
    commodities: []
  });

  async function getManyCommodity() {
    const { errorMessage, result, error } = await useCallApi({
      method: 'get',
      url: '/commodities'
    });

    if (errorMessage) {
      useErrorMessageHandler(error);

      return null;
    }

    state.commodities = result.commodities;
    state.total = result.count;

    return result;
  }

  async function postCommodity(data: any) {
    const { errorMessage, result, error } = await useCallApi({
      method: 'post',
      url: '/commodities',
      data: unref(data)
    });

    if (errorMessage) {
      useErrorMessageHandler(error);

      return null;
    }

    return result;
  }

  async function putCommodity(data: any) {
    const { errorMessage, result, error } = await useCallApi({
      method: 'put',
      url: '/commodities/' + data.id,
      data: unref(data)
    });

    if (errorMessage) {
      useErrorMessageHandler(error);

      return null;
    }

    return result;
  }

  async function deleteCommodity(data: any) {
    const { errorMessage, result, error } = await useCallApi({
      method: 'delete',
      url: '/commodities/' + data.id
    });

    if (errorMessage) {
      useErrorMessageHandler(error);

      return null;
    }

    return result;
  }
  return {
    ...toRefs(state),
    getManyCommodity,
    postCommodity,
    deleteCommodity,
    putCommodity
  };
});
